/* AUTH */
export const GET_REPOPROFILES = 'GET_REPOPROFILES';
export const GET_REPOPROFILES_SUCCESS = 'GET_REPOPROFILES_SUCCESS';
export const GET_REPOPROFILES_FAILED = 'GET_REPOPROFILES_FAILED';
